import { storeToRefs } from 'pinia';
import { type ModelRef, type Ref } from 'vue';
import { isNil } from 'lodash-es';
import { TagComponentSeverities } from '../../../../components/src/core/misc/tags/enums';
import useConfirmDialog from '../../../../components/src/core/overlays/confirm-dialog/composables/use-confirm-dialog';
import { useFormSidebarStore } from '@centric-os/stores/form-sidebar/use-form-sidebar-store';
import useTranslation from '../use-translation';

export default () => {
  const formSidebarStore = useFormSidebarStore();
  const { formSidebar, isFormDirty } = storeToRefs(formSidebarStore);

  const { translate } = useTranslation();

  const { showConfirmDialog } = useConfirmDialog({
    header: translate(`leaveDialog.header`, 'You have unsaved changes'),
    message: translate(
      `leaveDialog.message`,
      'If you close this sidebar, all changes will be lost.',
    ),
    acceptLabel: translate(`leaveDialog.acceptLabel`, 'Close'),
    rejectLabel: translate(`leaveDialog.rejectLabel`, 'Cancel'),
    severity: TagComponentSeverities.DANGER,
  });

  const openSidebarForm = async (
    sidebar: string,
    visibilityValue: Ref<boolean> | ModelRef<boolean> | undefined,
    successCallback = () => {},
    failureCallback = () => {},
  ) => {
    const handleSuccess = () => {
      if (!isNil(visibilityValue)) {
        visibilityValue.value = true;
      }
      formSidebar.value = sidebar;
      isFormDirty.value = false;
      successCallback();
    };
    if (isFormDirty.value) {
      showConfirmDialog(
        () => handleSuccess(),
        () => failureCallback(),
      );
    } else {
      handleSuccess();
    }
  };

  return { openSidebarForm };
};
